import { render, staticRenderFns } from "./ProductEditor.yaml?vue&type=template&id=f8b0b458&component"
import script from "./ProductEditor.yaml?vue&type=script&lang=ts&component"
export * from "./ProductEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports